import { register } from '@forter/core';
import { FcTable } from './FcTable.js';

register(FcTable);
